module.exports = __webpack_public_path__ + "img/vip_icon.be49608b.png";